import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://your-project.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY || 'your-anon-key'

// Détection de l'environnement
export const isDevelopment = process.env.NODE_ENV === 'development'
export const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
export const isLocalDev = isDevelopment && isLocalhost

// Vérification pour le développement
if (supabaseUrl === 'https://your-project.supabase.co' || supabaseKey === 'your-anon-key') {
  console.warn('⚠️  Variables d\'environnement Supabase non configurées. Utilisation des valeurs par défaut.')
  console.warn('📝 Configurez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_KEY dans votre fichier .env')
  
  if (isLocalDev) {
    console.info('🔧 Mode développement local détecté - Authentification bypass activée')
  }
}

export const supabase = createClient(supabaseUrl, supabaseKey) 